import { ParametersHandler } from "./util/brand/parameters.handler"
import { ClubTheme } from "./themes/club/club.theme"
import { TrackingEvent } from "./trackingEvent"
import { CustomTheme } from "./types/customTheme.interface"
import { ReadS3Theme } from "./themes/club/readS3.theme"

export class ThemeFactory {
    createTheme(): CustomTheme {
        const parameters = new ParametersHandler().parameters

        switch (parameters.realm?.toLowerCase()) {
            case "teachable":
                return new ReadS3Theme(parameters, new TrackingEvent())
            case "club":
                return new ClubTheme(parameters, new TrackingEvent())
            default:
                return new ReadS3Theme(parameters, new TrackingEvent())
        }
    }
}
